/* CRAVE LIGHT — cart, variant selection, gallery, drawer */
(function () {
  'use strict';

  const money = (cents) => {
    if (cents == null) return '';
    const v = (Number(cents) / 100).toFixed(2);
    const fmt = (window.Shopify && window.Shopify.moneyFormat) || '${{amount}}';
    return fmt
      .replace('{{amount}}', v)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', v.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString());
  };

  const escapeHtml = (s) => String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const toastEl = document.getElementById('cart-toast');
  let toastTimer;
  function toast(msg) {
    if (!toastEl) { console.log('[crave-light]', msg); return; }
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.hidden = true; }, 2400);
  }

  async function fetchCart() {
    try {
      const r = await fetch(root + 'cart.js', { credentials: 'same-origin' });
      return await r.json();
    } catch (e) { return null; }
  }
  async function changeLine(key, quantity) {
    try {
      const r = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity }),
      });
      return await r.json();
    } catch (e) { return null; }
  }
  async function addToCart(variantId, quantity, properties) {
    const body = { id: variantId, quantity: quantity || 1 };
    if (properties && Object.keys(properties).length) body.properties = properties;
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not add to cart');
    }
    return res.json();
  }
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = String(count);
    });
  }

  /* ---------- Cart drawer ---------- */
  const drawerEl = document.getElementById('cart-drawer');
  const drawerBody = drawerEl && drawerEl.querySelector('[data-cart-body]');
  const drawerFoot = drawerEl && drawerEl.querySelector('[data-cart-foot]');
  const drawerSubtotal = drawerEl && drawerEl.querySelector('[data-cart-subtotal]');

  function renderDrawer(cart) {
    if (!drawerEl || !cart) return;
    if (!cart.items || cart.items.length === 0) {
      drawerBody.innerHTML = '<div class="cl-drawer-empty">Your cart is empty.</div>';
      if (drawerFoot) drawerFoot.hidden = true;
      return;
    }
    const rows = cart.items.map((it) => {
      const img = it.image
        ? `<img src="${it.image.replace('.jpg', '_120x.jpg').replace('.png', '_120x.png').replace('.webp', '_120x.webp')}" alt="${escapeHtml(it.product_title)}" width="64" height="64" loading="lazy">`
        : '';
      return `
        <div class="cl-cart-line" data-line-key="${escapeHtml(it.key)}">
          <div class="cl-cart-line-media">${img}</div>
          <div>
            <div class="cl-cart-line-title">${escapeHtml(it.product_title)}</div>
            ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="cl-cart-line-variant">${escapeHtml(it.variant_title)}</div>` : ''}
            <div class="cl-cart-line-qty">
              <button type="button" class="cl-cart-qty-btn" data-cart-qty data-delta="-1" aria-label="Decrease">−</button>
              <span class="cl-cart-qty-n">${it.quantity}</span>
              <button type="button" class="cl-cart-qty-btn" data-cart-qty data-delta="1" aria-label="Increase">+</button>
              <button type="button" class="cl-cart-line-remove" data-cart-remove aria-label="Remove">Remove</button>
            </div>
          </div>
          <div class="cl-cart-line-price">${money(it.final_line_price)}</div>
        </div>
      `;
    }).join('');
    drawerBody.innerHTML = rows;
    if (drawerFoot) drawerFoot.hidden = false;
    if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
  }
  function openDrawer() {
    if (!drawerEl) return;
    drawerEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    fetchCart().then((c) => { renderDrawer(c); if (c) updateCartCount(c.item_count); });
  }
  function closeDrawer() {
    if (!drawerEl) return;
    drawerEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }
  function bindDrawer() {
    if (!drawerEl) return;
    drawerEl.addEventListener('click', async (e) => {
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
      const qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        const line = qtyBtn.closest('[data-line-key]');
        const key = line && line.getAttribute('data-line-key');
        const delta = Number(qtyBtn.dataset.delta || 0);
        const cur = Number(line.querySelector('.cl-cart-qty-n').textContent || 1);
        const next = Math.max(0, cur + delta);
        const cart = await changeLine(key, next);
        if (cart) { renderDrawer(cart); updateCartCount(cart.item_count); }
        return;
      }
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        const line = removeBtn.closest('[data-line-key]');
        const key = line && line.getAttribute('data-line-key');
        const cart = await changeLine(key, 0);
        if (cart) { renderDrawer(cart); updateCartCount(cart.item_count); }
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawerEl.getAttribute('aria-hidden') === 'false') closeDrawer();
    });
    document.querySelectorAll('[data-cart-toggle]').forEach((el) => {
      el.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); });
    });
  }

  /* ---------- Gallery ---------- */
  function isMobileViewport() {
    return window.matchMedia && window.matchMedia('(max-width: 960px)').matches;
  }

  function bindGallery(scope) {
    scope.querySelectorAll('[data-gallery]').forEach((gal) => {
      const track  = gal.querySelector('[data-gallery-track]') || gal;
      const thumbs = Array.from(gal.querySelectorAll('[data-gallery-thumb]'));
      const slides = Array.from(gal.querySelectorAll('[data-gallery-slide]'));
      const dots   = Array.from(gal.querySelectorAll('[data-gallery-dot]'));

      function markActive(idx) {
        thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.idx) === idx));
        dots.forEach((d) => d.classList.toggle('is-active', Number(d.dataset.idx) === idx));
        slides.forEach((s) => s.classList.toggle('is-active', Number(s.dataset.idx) === idx));
      }

      function activate(idx) {
        markActive(idx);
        // On mobile, scroll the carousel to the requested slide
        if (isMobileViewport()) {
          const slide = slides.find((s) => Number(s.dataset.idx) === idx);
          if (slide && slide.scrollIntoView) {
            slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        }
      }

      thumbs.forEach((t) => t.addEventListener('click', (e) => {
        e.preventDefault();
        activate(Number(t.dataset.idx) || 0);
      }));
      dots.forEach((d) => d.addEventListener('click', (e) => {
        e.preventDefault();
        activate(Number(d.dataset.idx) || 0);
      }));

      // Update active state when user swipes the carousel on mobile
      let scrollTimer;
      track.addEventListener('scroll', () => {
        if (!isMobileViewport()) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const trackRect = track.getBoundingClientRect();
          const trackCenter = trackRect.left + trackRect.width / 2;
          let nearestIdx = 0;
          let bestDist = Infinity;
          slides.forEach((s) => {
            const r = s.getBoundingClientRect();
            const c = r.left + r.width / 2;
            const d = Math.abs(c - trackCenter);
            if (d < bestDist) { bestDist = d; nearestIdx = Number(s.dataset.idx) || 0; }
          });
          markActive(nearestIdx);
        }, 80);
      }, { passive: true });

      gal.__activate = activate;
    });
  }

  /* ---------- Product form ---------- */
  function bindProductForm(scope) {
    scope.querySelectorAll('[data-product-form]').forEach((form) => {
      const variantsEl = form.querySelector('[data-variants]');
      let variants = [];
      try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; }
      catch (err) { console.warn('[crave-light] variant JSON parse failed', err); }

      const variantInput = form.querySelector('[data-variant-id]');
      const priceEl    = form.querySelector('[data-cur-price]');
      const strikeEl   = form.querySelector('[data-cur-strike]');
      const addBtn     = form.querySelector('[data-add-to-cart]');
      const buyBtn     = form.querySelector('[data-buy-now]');
      const optionRows = Array.from(form.querySelectorAll('[data-option-row]'));
      const poRows     = Array.from(form.querySelectorAll('[data-purchase-option]'));

      function getCurrentOptions() {
        // index by option position-1 (Shopify uses 1-based)
        const opts = [];
        optionRows.forEach((row) => {
          const pos = Number(row.dataset.optionPosition || 1) - 1;
          const pressed = row.querySelector('[data-option-value][aria-pressed="true"]');
          opts[pos] = pressed ? pressed.dataset.optionValue : null;
        });
        return opts;
      }

      function findVariant(opts) {
        if (!variants || !variants.length) return null;
        return variants.find((v) =>
          (v.options || []).every((o, i) => o === opts[i])
        ) || null;
      }

      function syncVariant() {
        const opts = getCurrentOptions();
        const v = findVariant(opts);
        if (v) {
          if (variantInput) variantInput.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (strikeEl) {
            if (v.compare_at_price && v.compare_at_price > v.price) {
              strikeEl.textContent = money(v.compare_at_price);
              strikeEl.hidden = false;
            } else {
              strikeEl.hidden = true;
              strikeEl.textContent = '';
            }
          }
          if (addBtn) {
            if (v.available) {
              addBtn.disabled = false;
              addBtn.textContent = addBtn.dataset.defaultLabel || 'Add to cart';
            } else {
              addBtn.disabled = true;
              addBtn.textContent = 'Sold out';
            }
          }
          if (buyBtn) {
            buyBtn.disabled = !v.available;
            if (!v.available) buyBtn.textContent = 'Sold out';
            else buyBtn.textContent = buyBtn.dataset.defaultLabel || 'Buy now';
          }
          // Swap gallery image if variant has featured_image — but only for the
          // single-PDP form (cards have no gallery and shouldn't move the PDP gallery).
          const isCardForm = !!form.closest('[data-card]');
          if (!isCardForm && v.featured_image && v.featured_image.id != null) {
            const section = form.closest('section, [data-gallery]');
            const gal = (section && section.querySelector('[data-gallery]')) || document.querySelector('[data-gallery]');
            if (gal && gal.__activate) {
              const slides = gal.querySelectorAll('[data-gallery-slide] img');
              let matchIdx = -1;
              slides.forEach((img, i) => {
                if (img && img.src && img.src.indexOf(String(v.featured_image.id)) !== -1) matchIdx = i;
              });
              if (matchIdx >= 0) gal.__activate(matchIdx);
            }
          }
        } else {
          if (variantInput) variantInput.value = '';
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
          if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Unavailable'; }
        }
      }

      // Bind option chip clicks
      optionRows.forEach((row) => {
        row.querySelectorAll('[data-option-value]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            row.querySelectorAll('[data-option-value]').forEach((x) => x.setAttribute('aria-pressed', 'false'));
            btn.setAttribute('aria-pressed', 'true');
            syncVariant();
          });
        });
      });

      // Purchase option (one-time / subscribe) toggle — visual only
      poRows.forEach((row) => {
        row.addEventListener('click', (e) => {
          poRows.forEach((x) => x.classList.remove('is-active'));
          row.classList.add('is-active');
          const radio = row.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
        });
      });

      // initial sync to make sure price/availability reflect first variant
      syncVariant();

      async function doAdd(redirect) {
        if (!variantInput || !variantInput.value) {
          toast('Please choose options');
          return;
        }
        const btn = redirect ? buyBtn : addBtn;
        const orig = btn ? btn.textContent : '';
        const purchaseRow = form.querySelector('[data-purchase-option].is-active');
        const purchase = purchaseRow ? purchaseRow.dataset.purchaseOption : 'one-time';
        const props = {};
        if (purchase === 'subscribe') props['Subscription'] = 'Every 30 days';
        if (btn) { btn.disabled = true; btn.textContent = redirect ? 'Loading…' : 'Adding…'; }
        try {
          await addToCart(variantInput.value, 1, props);
          const cart = await fetchCart();
          if (cart) { updateCartCount(cart.item_count); renderDrawer(cart); }
          if (redirect) {
            window.location.href = root + 'checkout';
            return;
          }
          toast('Added to cart');
          openDrawer();
        } catch (err) {
          toast(err.message || 'Could not add');
          console.error('[crave-light] add to cart failed', err);
        } finally {
          if (btn) { btn.disabled = false; btn.textContent = orig; }
        }
      }

      // Add to cart — our handler (opens drawer). Breeze does NOT intercept add-to-cart
      // because we set window.bzSeamlessAddToCartFlowEnabled = false.
      if (addBtn) addBtn.addEventListener('click', (e) => { e.preventDefault(); doAdd(false); });

      // Buy now — Breeze attaches a capture-phase listener on document. When it intercepts,
      // it calls stopImmediatePropagation() and our handler never fires. If we get here,
      // Breeze didn't intercept (not loaded, or declined) — fall back to standard /checkout.
      if (buyBtn) buyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        doAdd(true);
      });
    });
  }

  /* ---------- Accordions ---------- */
  function bindAccordions(scope) {
    // <details> handles open/close natively. Just leave summary clicks alone —
    // do not preventDefault.
  }

  /* ---------- Flavor switcher (PDP) ---------- */
  function bindFlavorSwitcher(scope) {
    scope.querySelectorAll('[data-flavor-switcher]').forEach((sw) => {
      const section = sw.closest('section') || sw.parentElement;
      if (!section) return;
      const panes = Array.from(section.querySelectorAll('[data-flavor-pane]'));
      const pills = Array.from(sw.querySelectorAll('[data-flavor-target]'));
      pills.forEach((p) => {
        p.addEventListener('click', (e) => {
          e.preventDefault();
          const idx = Number(p.dataset.flavorTarget || 0);
          pills.forEach((x) => x.setAttribute('aria-pressed', 'false'));
          p.setAttribute('aria-pressed', 'true');
          panes.forEach((pane) => {
            pane.classList.toggle('is-active', Number(pane.dataset.flavorPane) === idx);
          });
        });
      });
    });
  }

  /* ---------- Init ---------- */
  function init(scope) {
    scope = scope || document;
    bindGallery(scope);
    bindProductForm(scope);
    bindAccordions(scope);
    bindFlavorSwitcher(scope);
  }
  document.addEventListener('DOMContentLoaded', () => {
    init(document);
    bindDrawer();
    fetchCart().then((c) => { if (c) { updateCartCount(c.item_count); renderDrawer(c); } });
  });
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
